import { useEffect, useRef } from "react";

export const useDialogControl = (open: boolean) => {
  const ref = useRef<HTMLDialogElement>(null);

  const lockScroll = () => {
    const xPos = window.scrollX;
    const yPos = window.scrollY;
    window.document.onscroll = () => {
      window.scroll(xPos, yPos);
      window.document.body.style.overflow = "hidden";
    };
  };

  const unlockScroll = () => {
    window.document.body.style.overflow = "initial";
    window.document.onscroll = () => {};
  };

  useEffect(() => {
    const dialogEl = ref.current;
    if (!dialogEl) return;

    if (open) {
      if (!dialogEl.open) {
        dialogEl.showModal();
        dialogEl.scrollTop = 0;
      }
      lockScroll();
    } else {
      if (dialogEl.open) dialogEl.close();
      unlockScroll();
    }

    return () => {
      unlockScroll();
    };
  }, [open]);

  return ref;
};
